import { useContext } from 'react';
import { referenceDataContext } from './ReferenceDataContext';
import { Page } from 'components';
import { Results } from './components';


let ReferenceDatas = () => {
    const { isLoading } = useContext(referenceDataContext)

    return (
        <Page
            title="Reference data"
            addNewUrl={'/admin/referenceDataDetail/addnew'}
            isLoading={isLoading}
            useHeader={true}
        >
            <Results />
        </Page>
    )
}

export default ReferenceDatas;